module.exports = __webpack_public_path__ + "img/61.0b3cc35d.jpg";